import axios from 'axios';
import moment from 'moment';
import { all, put, takeLatest } from 'redux-saga/effects';
import { STATISTICS } from 'app/api-routes';
import { DATE_TIME_FORMAT } from 'app/types/constants';
import {
  biFormsByDateFailure,
  biFormsByDateRequest,
  biFormsByDateSuccess,
  biFormsBySiteAndDateFailure,
  biFormsBySiteAndDateRequest,
  biFormsBySiteAndDateSuccess,
  setLoadingState,
} from './actions';

function* biFormsBySiteAndDateSaga({
  payload: { month, year, siteID, userID, supervisorID, clientID, formID },
}) {
  const startDate = moment(`${year}-${month}`).startOf('month').format(DATE_TIME_FORMAT);
  const endDate = moment(`${year}-${month}`).endOf('month').format(DATE_TIME_FORMAT);

  const params = {
    startDate,
    endDate,
    timeZoneOffset: moment().utcOffset(),
  };

  if (siteID) {
    params.siteID = siteID;
  }

  if (userID) {
    params.userID = userID;
  }
  if (supervisorID) {
    params.supervisorID = supervisorID;
  }

  if (clientID) {
    params.clientID = clientID;
  }
  if (formID) {
    params.formID = formID;
  }

  try {
    yield put(setLoadingState(true));
    const { payload } = yield axios.get(`${STATISTICS}/forms/grouped-by-site-and-date`, {
      params,
    });
    yield put(biFormsBySiteAndDateSuccess(payload));
  } catch (err) {
    yield put(biFormsBySiteAndDateFailure(err));
  } finally {
    yield put(setLoadingState(false));
  }
}

function* biFormsByDateSaga({
  payload: { siteID, userID, supervisorID, clientID, formIDs, startDate, endDate },
}) {
  const params = { startDate, endDate, timeZoneOffset: moment().utcOffset() };

  if (siteID) {
    params.siteID = siteID;
  }

  if (userID) {
    params.userID = userID;
  }

  if (supervisorID) {
    params.supervisorID = supervisorID;
  }

  if (clientID) {
    params.clientID = clientID;
  }

  if (formIDs) {
    params.formIDs = formIDs;
  }

  try {
    const { payload } = yield axios.get(`${STATISTICS}/forms/grouped-by-date`, {
      params,
    });
    yield put(biFormsByDateSuccess(payload));
  } catch (err) {
    yield put(biFormsByDateFailure(err));
  }
}

export default function* () {
  yield all([
    takeLatest(biFormsBySiteAndDateRequest, biFormsBySiteAndDateSaga),
    takeLatest(biFormsByDateRequest, biFormsByDateSaga),
  ]);
}
